import { render, staticRenderFns } from "./AdminShipper.vue?vue&type=template&id=5663bc1b"
import script from "./AdminShipper.vue?vue&type=script&lang=js"
export * from "./AdminShipper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-apistage/apistage.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5663bc1b')) {
      api.createRecord('5663bc1b', component.options)
    } else {
      api.reload('5663bc1b', component.options)
    }
    module.hot.accept("./AdminShipper.vue?vue&type=template&id=5663bc1b", function () {
      api.rerender('5663bc1b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminShipper.vue"
export default component.exports